export default "__VITE_ASSET__BxpLy76O__"